import { Image, List, Spinner } from '@chakra-ui/react'
import { mdiDeleteOutline, mdiSync } from '@mdi/js'
import Icon from '@mdi/react'
import { CSSProperties, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Checkbox } from '@/components/ui/checkbox'
import { Flex } from '@/components/ui/flex'
import { Tooltip } from '@/components/ui/tooltip'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import useCustomMediaQuery from '@/hooks/useCustomMediaQuery'
import { toggleUploadMobileDrawer } from '@/store/gigiChat/ChatAtom'
import { IFileItem } from '@/types/documents/File'

const FileItem = ({
    onItemClick,
    index,
    isSelected,
    name,
    onDelete,
    onSumarize,
    isDeleteDisabled,
    loadingDeleteIndex,
    isDisabled,
}: IFileItem) => {
    const { t } = useTranslation()
    const [isMobile] = useCustomMediaQuery()
    const [isCheckboxSelected, setIsCheckboxSelected] = useState(isSelected)
    const [isHover, setIsHover] = useState(true)
    const onItemDelete = (fileName: string, index: number) => {
        onDelete(fileName, index)
    }

    const onMobileDrawerClose = () => {
        toggleUploadMobileDrawer()
    }

    const disabledItemStyle: CSSProperties = {
        opacity: '0.5',
        cursor: 'not-allowed',
        pointerEvents: 'none',
    }

    const disabledStyle =
        !isDisabled || isDeleteDisabled || !!loadingDeleteIndex || loadingDeleteIndex === 0 ? disabledItemStyle : undefined

    useEffect(() => {
        if (isCheckboxSelected !== isSelected) {
            setIsCheckboxSelected(isSelected)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSelected])

    return (
        <List.Item borderRadius="2px" style={disabledStyle} onMouseEnter={() => setIsHover(false)} onMouseLeave={() => setIsHover(true)}>
            <Flex alignItems="center" h="40px">
                {!isDisabled ? (
                    <Icon path={mdiSync} spin={true} vertical={true} size="18px" />
                ) : (
                    <Checkbox
                        variant="gsk"
                        alignItems="top"
                        onCheckedChange={() => {
                            onItemClick(!isSelected, index)
                            setIsCheckboxSelected(!isCheckboxSelected)
                        }}
                        checked={isCheckboxSelected}
                        marginTop="-2px"
                    />
                )}

                <Text as="span" truncate fontSize="14px" ml="16px" mr="8px" width={!isHover || isMobile ? '67%' : 'auto'}>
                    {name}
                </Text>

                <Box hidden={isMobile ? false : isHover} ml="auto" mr="10px" display="flex" alignItems="center">
                    {isDeleteDisabled ? (
                        <Spinner w="20px" h="20px" ml="auto" mr="16px" />
                    ) : (
                        <Box
                            onClick={() => {
                                onItemDelete(name, index)
                            }}
                            cursor="pointer"
                            ml="auto"
                            hidden={!isDisabled}
                            mr="16px"
                        >
                            <Icon path={mdiDeleteOutline} size="20px" />
                        </Box>
                    )}

                    <Tooltip
                        content={t('documents.summarize')}
                        variant={'gsk'}
                        positioning={{ placement: 'top' }}
                        contentProps={{ css: { letterSpacing: '0.25px' } }}
                    >
                        <Image
                            src={useColorModeValue('/assets/auto_fix_high.svg', '/assets/auto_fix_high_light.svg')}
                            onClick={() => {
                                onSumarize(`${t('documents.summarize')} ${name}`)
                                if (isMobile) {
                                    onMobileDrawerClose()
                                }
                            }}
                            cursor="pointer"
                        />
                    </Tooltip>
                </Box>
            </Flex>
        </List.Item>
    )
}

export default FileItem
